<template>
    <Card>
      <AjaxForm v-if="c" :route="'admin/ProductCategory/edit/'+c._id">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput label="عنوان" :model-value="c.title" placeholder="عنوان..." name="title" type="text"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput label="عنوان انگلیسی" :model-value="c.en_title" placeholder="عنوان انگلیسی..." name="en_title" type="text"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput label="آیکن" :model-value="c.icon" placeholder="آیکن..." name="icon" type="text"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="select" label="سردسته" select-label="title" reduce_select="_id"
                         name="parent_id"
            v-model="parent_id" :fetch-options="getProductCategoryForSelect"
                         :select-options="select_cat_options" placeholder="سردسته را انتخاب کنید"
            ></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput v-if="choose_guild" type="select" name="guild_id" v-model="guild"
                         label="صنف کاری"
                         :fetch-options="getGuildsForSelect" :select-options="select_guild_option"
                         select-label="title" reduce_select="_id"
                         placeholder="صنف کاری را انتخاب کنید"
            ></CustomInput>
            <div class="p-1" v-if="!choose_guild">صنف کاری : {{parent_id.guild_id.title}}</div>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput name="description" :model-value="c.description" label="توضیحات" placeholder="توضیحات..." type="textarea"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4 d-flex">
            <label class="mr-3">تصویر</label>
            <ImagePicker :file_url="(c.pic_url?c.pic_url:null)" :file_id="(c.pic_id?c.pic_id:null)" name="pic_id"></ImagePicker>
          </div>
        </div>
        <h5>ویژگی های محصولات دسته بندی</h5>
        <button type="button" @click="addNewAttr" class="btn btn-info mb-2">افزودن ویژگی جدید</button>
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <th style="width: 20%">ویژگی</th>
              <th style="width: 70%">مقادیر پیش فرض</th>
              <th style="width: 10%">حذف</th>
            </tr>
            </thead>
            <tbody>
            <PCatAttrItem @delete="deleteItem(index)" v-for="(item,index) in attributes" :key="item"  :item="item"></PCatAttrItem>
            </tbody>
          </table>
        </div>
        <div class="row">
          <div class="col-10 col-sm-10 col-md-5 mx-auto">
            <button class="btn btn-info btn-block">ویرایش اطلاعات</button>
          </div>
        </div>
      </AjaxForm>
      <div v-if="error" class="alert alert-danger">
        {{error}}
      </div>
    </Card>
</template>

<script>
import Card from "@/components/forms/Card";
import MasterLayout from "@/components/MasterLayout";
import AjaxForm from "@/components/forms/AjaxForm";
import CustomInput from "@/components/CustomInput";
import {ProductApi} from "@/api/ProductApi";
import PCatAttrItem from "@/components/PCatAttrItem";
import vSelect from 'vue-select'
import ImagePicker from "@/components/ImagePicker";
import {mapActions} from "vuex";

export default {
  name: "ProductCategoryEdit",
  components: {PCatAttrItem, CustomInput, AjaxForm, MasterLayout, Card,vSelect,ImagePicker},
  data(){
    return{
      select_cat_options : [],
      select_guild_option : [],
      attributes : [],
      loading : false,
      id : this.$route.params.id,
      c : null,
      error : null,
      guild : null,
      parent_id : null,
      category : null,
      choose_guild : true
    }
  },
  mounted() {
    this.setPageLoading(false);
    this.setPageTitle('ویرایش دسته بندی محصول');
    this.setShowHead(true);
    this.initPage();
  },
  methods : {
    ...mapActions('app',{
      setPageTitle:'setPageTitle',
      setPageLoading:'setPageLoading',
      setShowHead : 'setShowHead'
    }),
    async initPage()
    {
      this.setPageLoading(true);
      this.c = null;
      this.error = null;
      const id = this.$route.params.id;
      const result = await ProductApi.getCategoryInfoForEdit(id);
      if (result.ok)
      {
        this.c = result.category;
        if (this.c.guild_id)
        {
          this.guild = this.c.guild_id;
        }
        if (this.c.parent_id)
        {
          this.parent_id = this.c.parent_id;
          this.category = this.c.parent_id;
          this.choose_guild = true;
        }
        else
        {
          this.parent_id = {_id : '0',title : 'بدون سردسته'};
          this.select_cat_options = [{_id : '0',title : 'بدون سردسته'}]
        }
        this.attributes = this.c.attributes;
      }
      else
      {
        this.error = result.error;
      }
      this.setPageLoading(false);
    },
    async getProductCategoryForSelect(search, loading)
    {
      loading(true);
      if (search.length > 1)
      {
        const data = await ProductApi.getProductCategoryForSelectAjax(search);
        if (data.ok)
        {
          this.select_cat_options = data.cats;
        }
        else
            this.select_cat_options = [];
      }
      loading(false);
    },
    async getGuildsForSelect(search,loading)
    {
      loading(true);
      if (search.length > 1)
      {
        const data = await ProductApi.getGuildForSelectAjax(search);
        if (data.ok)
        {
          this.select_guild_option = data.guilds;
        }
        else
          this.select_guild_option = [];
      }
      loading(false);
    },
    addNewAttr()
    {
      const attributes = (this.attributes?this.attributes:[]);
      attributes.push({attr_id : null,attr_item_ids : [],required : null,options : []});
      this.attributes = attributes;
    },
    deleteItem(index)
    {
      this.attributes.splice(index,1);
    }
  },
  watch:{
    parent_id:{
      handler(category)
      {
        if (category)
          this.choose_guild = category._id === '0';
        else
          this.choose_guild = true;
      }
    }
  }
}
</script>

<style scoped>

</style>